module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "menu-wrap",
    class: _vm.isOpenMenu ? 'isOpen' : ''
  }, [_c('div', {
    staticClass: "menu-toggle",
    on: {
      "click": _vm.toggleOpen
    }
  }, [_c('div', {
    staticClass: "bar"
  })]), _vm._v(" "), _c('div', {
    staticClass: "menu-body"
  }, [_c('div', {
    staticClass: "menu-link-grid"
  }, [_c('div', {
    staticClass: "menu-link-top"
  }, [_c('ul', [_c('li', {
    staticClass: "selected menu-item home-menu"
  }, [_c('router-link', {
    attrs: {
      "to": '/' + _vm.switchLanguage + '/',
      "exact": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.toggleOpen.apply(null, arguments)
      }
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.$t("message.nav_home")))])])], 1), _vm._v(" "), _c('li', {
    staticClass: "sub-nav-parent menu-item prod-menu",
    on: {
      "click": _vm.openSubNav
    }
  }, [_c('p', [_c('b', [_vm._v(_vm._s(_vm.$t("message.nav_product")))])]), _vm._v(" "), _c('div', {
    staticClass: "sub-nav"
  }, [_c('router-link', {
    attrs: {
      "to": '/' + _vm.switchLanguage + '/granulate',
      "exact": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.toggleOpen.apply(null, arguments)
      }
    }
  }, [_c('span', {
    staticClass: "menu-item sub-item"
  }, [_vm._v(_vm._s(_vm.$t("message.nav_product_beads")))])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": '/' + _vm.switchLanguage + '/flakes',
      "exact": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.toggleOpen.apply(null, arguments)
      }
    }
  }, [_c('span', {
    staticClass: "menu-item sub-item"
  }, [_vm._v(_vm._s(_vm.$t("message.nav_product_flakes")))])])], 1)]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        return _vm.scrollToFooter()
      }
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.$t("message.nav_contact")))])])])]), _vm._v(" "), _c('div', {
    staticClass: "menu-link-bottom"
  }, [_c('div', {
    staticClass: "menu-lang-switcher",
    class: _vm.isOpen ? 'open' : ''
  }, [_c('span', [_vm._v("Language: ")]), _vm._v(" "), _c('div', {
    staticClass: "current-lang",
    on: {
      "click": function($event) {
        return _vm.toggleSwitch()
      }
    }
  }, [_c('span', {
    staticClass: "current-lang-indicator"
  }, [_vm._v("IT")])]), _vm._v(" "), _c('div', {
    staticClass: "drop-lang"
  }, [_c('div', {
    on: {
      "click": function($event) {
        return _vm.changeLanguage('it')
      }
    }
  }, [_c('router-link', {
    attrs: {
      "to": '/it' + '/' + this.$route.path.split('/')[2]
    }
  }, [_c('p', {
    staticClass: "option"
  }, [_c('span', {
    staticClass: "language"
  }, [_vm._v("IT")])])])], 1), _vm._v(" "), _c('div', {
    on: {
      "click": function($event) {
        return _vm.changeLanguage('en')
      }
    }
  }, [_c('router-link', {
    attrs: {
      "to": '/en' + '/' + this.$route.path.split('/')[2]
    }
  }, [_c('p', {
    staticClass: "option"
  }, [_c('span', {
    staticClass: "language"
  }, [_vm._v("EN")])])])], 1)])]), _vm._v(" "), _c('a', {
    staticClass: "external",
    attrs: {
      "href": "http://www.mairetecnimont.com",
      "target": "_blank"
    }
  }, [_vm._v("mairetecnimont.com")]), _vm._v(" "), _c('a', {
    staticClass: "external",
    attrs: {
      "href": "http://www.nextchem.com",
      "target": "_blank"
    }
  }, [_vm._v("nextchem.com")])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1eba4ede","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/Menu.vue
// module id = 393
// module chunks = 0